import { ShoppingBag } from 'lucide-react';

function StoreItemRow({ item }) {
  return (
    <div className="flex items-center gap-3 rounded-2xl border border-border bg-background p-3">
      <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-xl bg-baby-blue text-primary">
        <ShoppingBag size={28} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold">{item.name}</div>
        {item.tag && (
          <span className="mt-0.5 inline-block rounded-full bg-lilac px-2 py-0.5 text-[10px] font-semibold text-purple-700">
            {item.tag}
          </span>
        )}
      </div>
      <div className="shrink-0 text-right">
        <div className="text-sm font-bold text-primary">{item.price}</div>
        <button className="mt-1 rounded-full bg-primary px-3 py-1 text-xs font-medium text-primary-foreground">
          Buy
        </button>
      </div>
    </div>
  );
}

export default StoreItemRow;
